
export const initialState = {
    paged: 1,
    order: "",
    orderby: "",
    searchTerm: "",
    selectedFilters: {},
    filterOptions: {},
    requests: [],
    loaderMessage: "Loading Catalog",
    showLoader: true,
    isSubmitting: false,
    formDrawerOpen: false
}

export const initializer = (initialValue = initialState) => {
    let savedState = JSON.parse(localStorage.getItem("tooling-catalog-state"));
    if (savedState) {
        return { ...savedState, showLoader: true, formDrawerOpen: false, loaderMessage: "Loading Catalog" };
    } else {
        return initialState;
    }
}

export const reducer = (state = initialState, action) => {
    console.log("%c" + action.type, "color: orange", action.payload);
    switch (action.type) {
        case ACTIONS.SET_PAGED_NUMBER:
            return { ...state, paged: action.payload };
        case ACTIONS.SET_ORDER:
            return { ...state, order: action.payload };
        case ACTIONS.SET_ORDERBY:
            return { ...state, orderby: action.payload };
        case ACTIONS.SET_SEARCH_TERM:
            return { ...state, searchTerm: action.payload };
        case ACTIONS.SET_SELECTED_FILTERS:
            return { ...state, selectedFilters: action.payload };
        case ACTIONS.SET_FILTER_OPTIONS:
            return { ...state, filterOptions: action.payload };
        case ACTIONS.ADD_TO_REQUEST_CART:
            return { ...state, requests: [...state.requests, action.payload] };
        case ACTIONS.REMOVE_REQUEST_ITEM_BY_ID:
            return {
                ...state, requests: state.requests.filter(item => {
                    return item.id !== action.payload;
                })
            };
        case ACTIONS.UPDATE_REQUEST_ITEM_QTY_BY_ID:
            return {
                ...state, requests: state.requests.map(request => {
                    if (request.id === parseInt(action.payload.id)) {
                        return { ...request, qty: action.payload.qty }
                    } else {
                        return request;
                    }
                })
            };
        case ACTIONS.TOGGLE_IS_SUBMITTING:
            return { ...state, isSubmitting: !state.isSubmitting };
        case ACTIONS.SET_LOADING_MESSAGE:
            return { ...state, loaderMessage: action.payload };
        case ACTIONS.TOGGLE_LOADER:
            return { ...state, showLoader: !state.showLoader };
        case ACTIONS.TOGGLE_FORM_DRAWER:
            return { ...state, formDrawerOpen: action.payload };
        case ACTIONS.RESET_STATE:
            return initialState;
        default:
            return initialState;
    }
}

const ACTIONS = {
    SET_PAGED_NUMBER: "SET_PAGED_NUMBER",
    SET_ORDER: "SET_ORDER",
    SET_ORDERBY: "SET_ORDERBY",
    SET_SEARCH_TERM: "SET_SEARCH_TERM",
    SET_SELECTED_FILTERS: "SET_SELECTED_FILTERS",
    SET_FILTER_OPTIONS: "SET_FILTER_OPTIONS",
    ADD_TO_REQUEST_CART: "ADD_TO_REQUEST_CART",
    REMOVE_REQUEST_ITEM_BY_ID: "REMOVE_REQUEST_ITEM_BY_ID",
    UPDATE_REQUEST_ITEM_QTY_BY_ID: "UPDATE_REQUEST_ITEM_QTY_BY_ID",
    TOGGLE_IS_SUBMITTING: "TOGGLE_IS_SUBMITTING",
    TOGGLE_LOADER: "TOGGLE_LOADER",
    TOGGLE_FORM_DRAWER: "TOGGLE_FORM_DRAWER",
    SET_LOADING_MESSAGE: "SET_LOADING_MESSAGE",
    RESET_STATE: "RESET_STATE"
}